import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grow, IconButton } from '@material-ui/core';
import { Delete } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  item: {
    width: '100%',
    marginInline: 'auto',
    paddingRight: '20px',
    marginBottom: '8px',
    color: theme.palette.background.default,
    backgroundColor: theme.palette.info.main,
    borderRadius: '8px',
    borderBottomWidth: '3px',
    borderBottomColor: theme.palette.info.dark,
    borderBottomStyle: 'solid',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  itemInput: {
    width: '100%',
    height: '48px',
    border: 'none',
    outline: 'none',
    color: theme.palette.background.default,
    background: theme.palette.info.main,
    '& focus': {
      border: 'none',
      outline: 'none',
    },
  },
  removeButton: {
    color: theme.palette.background.default,
    marginRight: '5px',
  },
}));

export default function ConnectingListElement({ value, handleChange, handleRemove }) {
  const classes = useStyles();
  return (
    <Grow in={true}>
      <Box className={classes.item}>
        <IconButton className={classes.removeButton} onClick={handleRemove}>
          <Delete />
        </IconButton>
        <input type="text" className={classes.itemInput} value={value} onChange={e => handleChange(e.target.value)} />
      </Box>
    </Grow>
  );
}
